<template>
  <b-modal :id="id" :title="$t('size-cm-conversion-table.title')" centered>
    <size-cm-conversion-table></size-cm-conversion-table>
    <template #modal-footer="{ close }">
      <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'

import { ModalPlugin } from 'bootstrap-vue'

import SizeCmConversionTable from '@/components/tables/SizeCmConversionTable'
import i18n from '@/plugins/i18n.js'

Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'size-cm-conversion-table-modal',
  props: {
    id: {
      type: String,
      required: true,
    }
  },
  components: {
    SizeCmConversionTable
  }
};
</script>
